import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import { HttpClient } from '@angular/common/http';
import { state2 } from '../shared/state';
import { IAgendapuntDb } from '../shared/offline/cobradb';
import { map, mergeMap, tap } from 'rxjs/operators';
import { StandpuntStatus, IZittingResult, IDetailZitting } from '../detail-zitting/detail-zitting.service';
import { replace } from '../shared/immutable';

export interface IStandpuntStatus {
  StandpuntId: number;
  Status: number;
  Commentaar: string;
  AgendapuntId: number;
  PersoonId?: number;
}

export interface IAgendapuntStandpuntInfo {
  Id: number;
  Titel: string;
  HeeftSubPunten: boolean;
  SubPunt: boolean;
  SubPuntenZijnOpties: boolean;
  Standpunt?: IStandpuntStatus;
  StandpuntAanvaard?: number;
  StandpuntBespreken?: number;
  StandpuntOnbepaald?: number;
  OnbepaaldIsBespreken?: number;
  isEditing?: boolean;
}


@Injectable()
export class StandpuntService {

  constructor(private appService: AppService,
    private http: HttpClient) { }

  public getStandpunten(puntId: number) {
    const url = this.appService.getUrl(`api/standpunt/getstandpuntforagendapunt?puntId=${puntId}`);
    return this.http.post<IAgendapuntStandpuntInfo[]>(url, {});
  }

  public updateCommentaar(puntStandpuntInfo: IAgendapuntStandpuntInfo, newStandpuntStatus: IStandpuntStatus) {
    const url = this.appService.getUrl(`api/standpunt/addorupdate?puntId=${puntStandpuntInfo.Id}`);
    return this.http.post<IAgendapuntStandpuntInfo[]>(url, newStandpuntStatus);
  }

  public update(zittingId: number, puntId: number, /*standpunt: IAgendapuntStandpuntInfo,*/ newStandpuntStatus: IStandpuntStatus) {
    const url = this.appService.getUrl(`api/standpunt/addorupdate?puntId=${puntId}`);
    return this.http.post<IAgendapuntStandpuntInfo[]>(url, newStandpuntStatus).pipe(tap(result => state2.removeSubKey('detailzittingdata', zittingId)));
  }


}
